import axios from 'axios'
import * as types from './mutation_types'

export default {
  async getData ({commit, rootState}, {meta}) {
    commit(types.LOAD_DATA, meta)
  }
}
